module.exports = "<iframe [src]=\"url\" class=\"asp-iframe\"></iframe>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/fakturisanje/fakturisanje.component.html
// module id = ./src/app/pages/fakturisanje/fakturisanje.component.html
// module chunks = main